import { BaseStore } from 'fluxible/addons';
import without from 'lodash/without';
import intersection from 'lodash/intersection';
import includes from 'lodash/includes';

class ContestProductsStore extends BaseStore {
    constructor(dispatcher) {
        super(dispatcher);

        this.products = [];
        this.bundles = {};
        this.selectedProducts = [];
        this.purchaseProductsApiUrl = null;
        this.loadingPaymentRequest = false;
        this.paymentRequestXhr = null;
        this.paymentRequest = null;
        this.currency = null;
        this.grandTotalAmount = 0;
        this.taxAmount = 0;
        this.isLoading = true;
    }

    updateProducts(payload) {
        this.products = payload.products;
        this.bundles = payload.bundles;
        this.purchaseProductsApiUrl = payload.purchaseProductsApiUrl;
        this.currency = payload.currency;
        this.isLoading = false;
        this.emitChange();
    }

    calculatePrice(property) {
        let selectedProducts = this.selectedProducts.slice();
        let selectedBundles = intersection(Object.keys(this.bundles), selectedProducts);

        selectedBundles.forEach((id) => {
            selectedProducts = without(selectedProducts, ...this.bundles[id]);
        });

        return this.products
            .filter((addon) => includes(selectedProducts, addon.id))
            .map((addon) => addon[property])
            .reduce((prev, current) => prev + current, 0);
    }

    updateSelectedProducts(payload) {
        this.selectedProducts = payload.selectedProducts;
        const taxAmount = this.calculatePrice('taxAmount');

        if (taxAmount) {
            this.taxAmount = taxAmount;
            this.grandTotalAmount = this.calculatePrice('totalAmount') + taxAmount;
        } else {
            this.grandTotalAmount = this.calculatePrice('totalAmount');
        }

        this.emitChange();
    }

    startLoading() {
        this.loadingPaymentRequest = true;
        this.emitChange();
    }

    stopLoading(payload) {
        this.loadingPaymentRequest = false;
        this.paymentRequestXhr = null;
        if (payload && payload.paymentRequest) {
            this.paymentRequest = payload.paymentRequest;
        } else {
            this.paymentRequest = null;
        }
        this.emitChange();
    }

    saveOrReplacePaymentRequestXhr(payloadXhr) {
        if (this.paymentRequestXhr) {
            this.paymentRequestXhr.abort();
        }
        this.paymentRequestXhr = payloadXhr;
        this.emitChange();
    }

    resetPaymentRequest() {
        this.paymentRequest = null;
        this.emitChange();
    }
}

ContestProductsStore.storeName = 'ContestProductsStore';
ContestProductsStore.handlers = {
    LOAD_PRODUCTS_SUCCESS: 'updateProducts',
    LOAD_PRODUCTS_PAYMENT_REQUEST_START: 'startLoading',
    LOAD_PRODUCTS_PAYMENT_REQUEST_FAILED: 'stopLoading',
    LOAD_PRODUCTS_PAYMENT_REQUEST_SUCCESS: 'stopLoading',
    UPDATE_SELECTED_PRODUCTS: 'updateSelectedProducts',
    SAVE_OR_REPLACE_PAYMENT_REQUEST_XHR: 'saveOrReplacePaymentRequestXhr',
    RESET_PAYMENT_REQUEST: 'resetPaymentRequest',
};

export default ContestProductsStore;



// WEBPACK FOOTER //
// ./src/web/js/contest/stores/contest-products-store.js